import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "error", "field", "dr_rev", "first_name", "middle_name", "last_name", "suffixes"]
  static values = { currentSlug: String, checkUrl: String }

  connect() {
    this.change()
    this.nameChange()
  }

  change() {
    const newSlug = this.fieldTarget.value.replace(/\s+/g, "-").toLowerCase()
    if (newSlug.length === 0) {
      this.markError(false)
      return
    }
    const url = `${this.checkUrlValue}?slug=${encodeURIComponent(newSlug)}`
    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" } })
      .then((r) => r.json())
      .then(({ taken, slug }) => {
        if (taken && slug !== this.currentSlugValue) {
          this.markError(true)
        } else {
          this.markError(false)
        }
      })
      .catch(() => this.markError(false))
  }

  markError(state) {
    if (state) {
      this.fieldTarget.classList.add("is-danger")
      this.errorTarget.classList.remove("hidden")
      this.buttonTarget.classList.add("hidden")
    } else {
      this.fieldTarget.classList.remove("is-danger")
      this.errorTarget.classList.add("hidden")
      this.buttonTarget.classList.remove("hidden")
    }
  }

  nameChange() {
    const el = document.getElementById("split-name")
    if (!el) return
    el.innerHTML =
      this.dr_revTarget.value +
      " " +
      this.first_nameTarget.value +
      " " +
      this.middle_nameTarget.value +
      " " +
      this.last_nameTarget.value +
      " " +
      this.suffixesTarget.value
  }
}
